import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export var getAmktBootstrap = function getAmktBootstrap(mpacBaseUrl) {
  return fetchOk(mpacBaseUrl + "/rest/internal/frontend/bootstrap").then(function (response) {
    return response.json();
  }).catch(function (_) {
    return {
      ldUserKey: 'ANY_USER'
    };
  });
};